import { ContentHubData } from "@app/types/ServerCustomContext";
import VideoOverlayPortrait from "@components/Modules/VideoOverlayPortrait/VideoOverlayPortrait";
import { ReactNode } from "react";

import { HomeContentBlocks } from "../../Home/Elements/utils";

type Props = {
  data?: Omit<ContentHubData, "metaData">;
};

export default function ContentHubVideoOverlayPortrait({
  data,
}: Props): ReactNode {
  const ContentVideoBlock = data?.videoPlaylist;
  if (!ContentVideoBlock?.videoTeaser) return null;

  const content: HomeContentBlocks = {
    items: ContentVideoBlock.videoTeaser,
    // TODO: Can be configured for individual pub
    title: "videos",
    titleZH: "视频",
    type: "list",
    url: "",
  };

  return <VideoOverlayPortrait content={content} />;
}
